
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { Message } from "element-ui";
import { getHenganLoadingPlans, saveTransshipDeliveryInfo } from "@/api/hengan-loading-plan";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "Transship",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private henganLoadingPlans: HenganLoadingPlanTableRowData[] = [];
  private dialogTableVisible = false;
  private currentRowId: string;

  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    transshipDelivery: true,
    code: null,
    startDate: null,
    endDate: null,
    dateRange: null
  };

  private listCharage = {
    henganLoadingPlanId: null,
    warehouseAddress: null,
    warehouseName: null,
    contacts: null,
    contactInformation: null,
    transshipWarehouseDeliveryNoteCode: null,
    remark: null,
    transshipWarehouseInCharage: null,
    freight: null,
    otherFee: null,
    transshipRemark: null
  }

  created() {
    this.getList();
  }

  private total = 0;
  private listLoading = false;

  private async getList() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    }
    const params = { ...this.listQuery };
    params.dateRange = null;
    getHenganLoadingPlans(params)
      .then((res: any) => {
        this.total = res.total;
        this.henganLoadingPlans = res.content;
      })
      .catch((error) => {
        Message.error({
          message: error.message,
          duration: 2000,
        });
      });
    return;
  }

  private onCilck(data: TransshipInfo, id: string) {
    this.dialogTableVisible = true;
    this.currentRowId = id;
    if (data) {
      this.listCharage = deepClone(data);
    }else {
      this.listCharage = {
        henganLoadingPlanId: null,
        warehouseAddress: null,
        warehouseName: null,
        contacts: null,
        contactInformation: null,
        transshipWarehouseDeliveryNoteCode: null,
        remark: null,
        transshipWarehouseInCharage: null,
        freight: null,
        otherFee: null,
        transshipRemark: null
      }
    }
    return;
  }

  private async submitTransshipDeliveryInfo() {
    saveTransshipDeliveryInfo(this.currentRowId, this.listCharage).then(() => {
      this.dialogTableVisible = false;
      this.getList();
    });
  }
}

class HenganLoadingPlanTableRowData {
  id: string;
  code: string;
  customerAbbr: string;
  customerId: string;
  createdAt: Date;
  state: { name: string; desc: string };
  remark: string;
  transshipDelivery: boolean;
  transshipDeclaration: boolean;
  shippingOrderId: string;
  shippingOrderCode: string;
  loadingInOneOrMorePlaces: string;
  billOfLadingCode: string;
  deliveryListId: string;
  containerTypeInfos: string[];
  packingQuantity: string;
  packingGroWeight: string;
  packingVolue: string;
  transshipInfo: TransshipInfo;
}

class TransshipInfo {
  id: string;
  contactInformation: string;
  contacts: string;
  transshipWarehouseDeliveryNoteCode: string;
  warehouseName: string;
  warehouseAddress: string;
  transshipWarehouseInCharage: string;
  freight: string;
  otherFee: string;
  transshipRemark: string;
}
